import { CodedError } from './CodedError';
import { errorCodes } from './constants/errorCodes';

export class HomeChannelForbiddenError extends CodedError {
  static get errorName() {
    return errorCodes.homeChannelForbiddenError.code;
  }

  constructor(message: string = errorCodes.homeChannelForbiddenError.message) {
    super(message);
    this.code = errorCodes.homeChannelForbiddenError.code;
    this.message = `${message} ${errorCodes.homeChannelForbiddenError.code}`;
    this.name = errorCodes.homeChannelForbiddenError.name;
    this.status = errorCodes.homeChannelForbiddenError.status;
  }
}
